module.exports = __webpack_public_path__ + "img/2024-12-12c_3.17e836a7.jpg";